import { useEffect, useRef } from "react";
import { TerminalSquare, Trash2 } from "lucide-react";

const COLOR = {
    info: "text-[#a1a1aa]",
    ok: "text-[#10B981]",
    error: "text-[#ef4444]",
    tx: "text-[#3B82F6]",
    rx: "text-[#F59E0B]",
    serial: "text-[#d4d4d8]",
};

const PREFIX = {
    info: "•",
    ok: "✓",
    error: "✗",
    tx: "»",
    rx: "«",
    serial: "|",
};

function fmtTime(ts) {
    const d = new Date(ts);
    return (
        d.getHours().toString().padStart(2, "0") +
        ":" +
        d.getMinutes().toString().padStart(2, "0") +
        ":" +
        d.getSeconds().toString().padStart(2, "0") +
        "." +
        d.getMilliseconds().toString().padStart(3, "0")
    );
}

export const LogConsole = ({ entries, onClear }) => {
    const scrollRef = useRef(null);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [entries]);

    return (
        <div
            data-testid="log-console"
            className="flex-1 flex flex-col border border-[#27272a] bg-black overflow-hidden min-h-[400px]"
        >
            <div className="bg-[#161618] border-b border-[#27272a] px-4 py-2.5 flex justify-between items-center">
                <div className="flex items-center gap-2 text-xs font-mono text-[#a1a1aa] uppercase tracking-[0.15em]">
                    <TerminalSquare className="w-3.5 h-3.5" />
                    <span>device log</span>
                </div>
                <button
                    type="button"
                    data-testid="log-clear-button"
                    onClick={onClear}
                    className="text-xs font-mono text-[#a1a1aa] hover:text-[#ededed] flex items-center gap-1.5 transition-colors"
                >
                    <Trash2 className="w-3 h-3" />
                    CLEAR
                </button>
            </div>

            <div
                ref={scrollRef}
                className="terminal-scroll flex-1 p-4 overflow-y-auto font-mono text-[13px] leading-relaxed"
            >
                {entries.length === 0 ? (
                    <div className="text-[#52525b] italic">
                        <span className="blink">▊</span> awaiting input…
                    </div>
                ) : (
                    entries.map((e) => (
                        <div key={e.id} className="flex gap-3">
                            <span className="text-[#3f3f46] shrink-0">
                                {fmtTime(e.ts)}
                            </span>
                            <span
                                className={`${COLOR[e.level] || COLOR.info} shrink-0 w-3`}
                            >
                                {PREFIX[e.level] || "·"}
                            </span>
                            <span
                                className={`${COLOR[e.level] || COLOR.info} break-all`}
                                data-testid="log-entry"
                            >
                                {e.msg}
                            </span>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};
